module.exports = __webpack_public_path__ + "static/mtb-8-96d982957b7cc2aab1a3d6b6ae5086ff.jpg";